__turbopack_context__.v({
  "btn": "Button-module__8RiFmG__btn",
  "lg": "Button-module__8RiFmG__lg",
  "md": "Button-module__8RiFmG__md",
  "primary": "Button-module__8RiFmG__primary",
  "secondary": "Button-module__8RiFmG__secondary",
  "sm": "Button-module__8RiFmG__sm",
  "tertiary": "Button-module__8RiFmG__tertiary",
});
